export default "__VITE_ASSET__DeZsWyDr__"